import { render, staticRenderFns } from "./retellLecture.vue?vue&type=template&id=56ab5a1b&scoped=true&"
import script from "./retellLecture.vue?vue&type=script&lang=js&"
export * from "./retellLecture.vue?vue&type=script&lang=js&"
import style0 from "./retellLecture.vue?vue&type=style&index=0&id=56ab5a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab5a1b",
  null
  
)

export default component.exports